import {
    CANVAS_BG,
    HOVER_OUTLINE,
    READOUT,
    TILE_OUTLINE,
    TILE_RADIUS,
    tileRingSx,
} from '../chrome';

/**
 * The box every tile of the console draws itself in: a black pane under a
 * title bar, rounded on top like the rest of the console and square where
 * it meets the row footer, clipped so its bars and its content stay inside
 * the corners, and ringed. The hovered tile reads teal; every other tile
 * keeps the neutral hairline that frames it as its own pane. Tabular
 * figures, so readouts do not jitter as digits change.
 */
export function tileFrameSx(isActive: boolean) {
    return {
        position: 'relative' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        height: '100%',
        bgcolor: CANVAS_BG,
        color: READOUT,
        borderRadius: TILE_RADIUS,
        overflow: 'hidden',
        '&::after': {
            content: '""',
            ...tileRingSx('1px', isActive ? HOVER_OUTLINE : TILE_OUTLINE),
        },
        fontVariantNumeric: 'tabular-nums',
    };
}
